import { CSSProperties } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { CARD_FIELD_TYPE, CardFiled, CardsContent, ICard, ICardFieldValue, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import CardFieldContent from "./CardFieldContent"

/* Protopia Ecosystem component */
export interface ICardFieldProps {
   i: number
   field: CardFiled
   cardData: ICard
   value: ICardFieldValue
   section: ILandingSection
   cardOrder?: number
   contentData?:CardsContent
} 
const CardField = (props: ICardFieldProps): JSX.Element => {
    return props.field.isHidden
        ?
        <></>
        :
        <CardFieldContainer {...props}>
            <CardFieldContent {...props} />
        </CardFieldContainer>
}
export default CardField


export const getGridStyle = (props: ICardFieldProps): any => {
    return {}
    // return !!props.contentData?.grid
    //     ?
    //     props.contentData.grids[props.i]
    //     :
    //     {}
}

export interface ICardFieldContProps extends ICardFieldProps{
    children: JSX.Element
}
const CardFieldContainer = ( props: ICardFieldContProps): JSX.Element => {
    const br = props.contentData?.border_radius 
    const border_radius: number[] = !Array.isArray(br)
        ?
        [br || 0, br || 0, br || 0, br || 0, ] as number[]
        :
        (br || []) as number[]
    const l: number = (props.contentData?.cards || []).length - 1

    const medallionPrev = ():boolean => {
        const prevField = props.contentData?.card_fields[props.i - 1]
        return prevField?.type === CARD_FIELD_TYPE.MEDALLION  

    }

    const medallionNext = () => {
        const prevField = props.contentData?.card_fields[props.i + 1]
        return prevField?.type === CARD_FIELD_TYPE.MEDALLION
            ?
            getCssDemention(prevField.radius/2, "40px")
            :
            0
    }

    const medallionRadiusPrev = (): string => {
        const prevField = props.contentData?.card_fields[props.i - 1]
        if( prevField?.type === CARD_FIELD_TYPE.MEDALLION) {
            const padding = getCssDemention( prevField.radius / 2 + 13, "40px")
            const firstMedallionPadder: any = document.querySelector(`.landing-card-body-${ props.cardData.id } .pe-card-field[data-i="${ props.i }"] .medallion-padder`)
            if(!!firstMedallionPadder) {
                addCSSClass(
                    `medallion-padder-${props.cardData.id + "-" + props.i}`,
                    `.medallion-padder-${props.cardData.id + "-" + props.i} {
                        padding-top: ${padding}!important;
                    }`
                
                )
                firstMedallionPadder.classList.add( `medallion-padder-${props.cardData.id + "-" + props.i}` )
            }
            else {
                return padding
            }
        }
        return "0"
    }

    const style: CSSProperties = {
        ...props.contentData?.card_fields[props.i].style,
        ...props.field?.card_fields_style,
        ...props.value?.card_fields_style,
        ...getGridStyle(props),
        borderTopLeftRadius: !!props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            ?
            props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            :
            props.i === 0 ? border_radius[0] - 1 || 3 : 0,
        borderBottomLeftRadius: !!props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            ?
            props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            :
            props.i === l ? border_radius[1] - 1 || 3 : 0,
        borderBottomRightRadius: !!props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            ?
            props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            :
            props.i === l ? border_radius[2] - 1 || 3 : 0,
        borderTopRightRadius: !!props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            ?
            props.contentData?.card_fields[props.i].card_fields_style?.borderRadius
            :
            props.i === 0 ? border_radius[3] - 1 || 3 : 0,
        overflow: (props.i !== 0 && props.i !== l) || 
            props.contentData?.card_fields[props.i].type === CARD_FIELD_TYPE.MEDALLION ||
            props.field?.card_fields_style?.position === "absolute"
            ? 
            "visible" 
            : 
            props.field.type === CARD_FIELD_TYPE.SPEECH_BUBBLE
                ?
                "inherit"
                :
                "hidden",
        paddingTop:                 medallionPrev() ? medallionRadiusPrev() : (props.value?.style?.paddingTop),
        // paddingBottom:           medallionNext() ? medallionNext() : (props.value?.style?.paddingBottom || 0 ),
        //transform:               `rotate(${ Math.random() * 14 - 7 }deg)`
        zIndex: props.contentData?.card_fields[props.i].type === CARD_FIELD_TYPE.MEDALLION ? 100 : props.i
    }

    return <div 
        className={ `pe-card-field ${ props.value?.className || "" }` } 
        data-i={ props.i }
        data-field-type={ props.field.type } 
        data-field-pseudonym={ props.field.pseudonym } 
        data-grid-column-id={props.field.gridColumnCroupID}
        data-grid-row-id={props.field.gridRowCroupID}
        style={ style } 
    >
        {props.children} 
    </div>
}

